import styled from 'styled-components';
import { isMobile } from 'utils';

export const SignUpInfoBlock = styled.div`
  color: var(--v3-text-color-secondary);
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.32px;
`;

export const SignUpInfoLink = styled.span`
  cursor: pointer;
  color: var(--v3-text-color);
  font-size: 15px;
  text-decoration: underline;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.32px;
  white-space: nowrap;
`;

export const SpinWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
`;

export const ModalBody = styled.div`
  width: ${isMobile() ? '100vw' : '500px'};
  min-height: 500px;
  max-height: ${isMobile() ? '100vh' : '90vh'};
`;
